import {
  LOAD_DRIVINGLICENSESCANLOG,
  LOAD_DRIVINGLICENSESCANLOG_PREVIEW,
  LOAD_VEHICLE_DRIVINGLICENSESCANLOG,
  LOAD_VEHICLE_TYPE_DRIVINGLICENSESCANLOG,
} from './actions'

const initialState = {
  drivinglicensescanlogUrl: '',
  vehicleLists: [],
  vehicleTypeLists: [],
  drivinglicensescanlogLoading: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case LOAD_DRIVINGLICENSESCANLOG.REQUEST:
    case LOAD_DRIVINGLICENSESCANLOG_PREVIEW.REQUEST:
      const { loading } = action.payload
      return {
        ...state,
        drivinglicensescanlogLoading: loading,
      }
    case LOAD_DRIVINGLICENSESCANLOG.SUCCESS:
    case LOAD_DRIVINGLICENSESCANLOG_PREVIEW.SUCCESS:
      return {
        ...state,
        drivinglicensescanlogUrl: action.payload.data.data,
        drivinglicensescanlogLoading: false,
      }
    case LOAD_VEHICLE_DRIVINGLICENSESCANLOG.REQUEST:
      const { loading_vehicle } = action.payload
      return {
        ...state,
        drivinglicensescanlogLoading: loading_vehicle,
      }
    case LOAD_VEHICLE_DRIVINGLICENSESCANLOG.SUCCESS:
      return {
        ...state,
        vehicleLists: action.payload.data.data,
        drivinglicensescanlogLoading: false,
      }
    case LOAD_VEHICLE_TYPE_DRIVINGLICENSESCANLOG.SUCCESS:
      return {
        ...state,
        vehicleTypeLists: action.payload.data.data,
      }
    default:
      return state
  }
}
